var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoomBlueSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6542 13.3238L11.6616 13.3273H11.6653L8.00004 15.3334L4.33661 13.3273H4.33291L4.34586 13.322L1.33337 11.6667V4.3334L8.00004 0.666738L14.6667 4.3334V11.6667L11.6542 13.3238ZM7.4582 2.15456L4.81188 3.61065L2.47685 4.99162L2.4152 7.36898V10.4522L7.4582 7.67924V2.15456ZM2.9367 11.3582L5.42769 12.7297L8.00004 14.0173L10.5687 12.7332L13.0689 11.3582L8.00374 8.57299L2.9367 11.3582ZM13.5849 7.36017L13.5232 4.99162L11.203 3.61946L8.54188 2.15632V7.67571L13.5849 10.4486V7.36017Z",
    fill: "#0783EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.54995 4.37567V8.83324C6.54995 9.137 6.30371 9.38324 5.99995 9.38324C5.69619 9.38324 5.44995 9.137 5.44995 8.83324V6.29081L4.54995 6.81581V9.99991C4.54995 10.3037 4.30371 10.5499 3.99995 10.5499C3.69619 10.5499 3.44995 10.3037 3.44995 9.99991V6.184L6.54995 4.37567Z",
    fill: "#0783EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomBlueSmall);
export default __webpack_public_path__ + "static/media/RoomBlueSmall.651ef4c4489093a808e04dc6f1f5b397.svg";
export { ForwardRef as ReactComponent };